export default __webpack_public_path__ + "static/media/64.76f3fd05.jpg";